var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9727 45.2667H14.3593C10.1193 45.2667 6.66602 48.72 6.66602 52.96V58C6.66602 58.7467 7.26602 59.3333 7.99935 59.3333H29.3327C30.066 59.3333 30.666 58.7467 30.666 58V52.96C30.666 48.72 27.2127 45.2667 22.9727 45.2667ZM11.746 36.5067C11.746 40.3333 14.8527 43.4267 18.666 43.4267C22.4793 43.4267 25.586 40.3333 25.586 36.5067C25.586 32.6933 22.4793 29.5867 18.666 29.5867C14.8527 29.5867 11.746 32.68 11.746 36.5067ZM54.4127 36.5067C54.4127 40.3333 57.5193 43.4267 61.3327 43.4267C65.146 43.4267 68.2527 40.3333 68.2527 36.5067C68.2527 32.6933 65.146 29.5867 61.3327 29.5867C57.5193 29.5867 54.4127 32.68 54.4127 36.5067ZM65.6393 45.2667H57.026C52.786 45.2667 49.3327 48.72 49.3327 52.96V58C49.3327 58.7467 49.9327 59.3333 50.666 59.3333H71.9993C72.7327 59.3333 73.3327 58.7467 73.3327 58V52.96C73.3327 48.72 69.8793 45.2667 65.6393 45.2667ZM31.066 29.5867C31.066 34.5067 35.066 38.52 39.9993 38.52C44.9193 38.52 48.9327 34.52 48.9327 29.5867C48.9327 24.6533 44.9327 20.64 39.9993 20.64C35.0793 20.6533 31.066 24.6533 31.066 29.5867Z",
    fill: "url(#paint0_linear_311_1009)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.667 52.96C46.667 48.96 48.9604 45.48 52.2937 43.7467C50.5204 42.2133 48.2137 41.32 45.8004 41.32H34.2137C31.787 41.32 29.4804 42.2133 27.707 43.76C31.0404 45.48 33.3337 48.96 33.3337 52.96V58C33.3337 58.48 33.2537 58.92 33.0937 59.3467H46.907C46.747 58.92 46.667 58.48 46.667 58V52.96Z",
    fill: "url(#paint1_linear_311_1009)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_311_1009",
    x1: 74.1966,
    y1: 21.2281,
    x2: 39.6897,
    y2: 79.0434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_311_1009",
    x1: 52.6123,
    y1: 41.594,
    x2: 35.052,
    y2: 64.8845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F45634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504,
    stopColor: "#9D2161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1C49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.f02013c7d110bf115293c20df32139c1.svg";
export { ForwardRef as ReactComponent };